module.exports = __webpack_public_path__ + "img/nut-chestnuts-190x100.a5f87751.jpg";